export const GOAL_INTENTS = {
  MANAGE_GOALS: 'MANAGE_GOALS',
  COMPANY_GOALS: 'COMPANY_GOALS',
  ARCHIVED_GOALS: 'ARCHIVED_GOALS',
  UPLOAD_GOALS: 'UPLOAD_GOALS',
  GOAL_REPORTS: 'GOAL_REPORTS',
  DATA_EXPORTS: 'DATA_EXPORTS',
  CHECK_IN_GOALS: 'CHECK_IN_GOALS',
  GOAL_SETTINGS: 'GOAL_SETTINGS',
};

export const INITIATIVE_INTENTS = {
  MY_INITIATIVES: 'MY_INITIATIVES',
};

export const FEEDBACK_INTENTS = {
  COMPETENCIES: 'COMPETENCIES',
  TEAM_FEEDBACK: 'TEAM_FEEDBACK',
  COMPANY_PRAISES: 'COMPANY_PRAISES',
  FEEDBACK_PENDING_ON_ME: 'FEEDBACK_PENDING_ON_ME',
  FEEDBACK_RECEIVED_BY_ME: 'FEEDBACK_RECEIVED_BY_ME',
  FEEDBACK_SHARED_BY_ME: 'FEEDBACK_SHARED_BY_ME',
  FEEDBACK_REQUESTS_FROM_ME: 'FEEDBACK_REQUESTS_FROM_ME',
  FEEDBACK_TABLE_REPORTS: 'FEEDBACK_TABLE_REPORTS',
  FEEDBACK_GRAPH_REPORTS: 'FEEDBACK_GRAPH_REPORTS',
  COMPETENCY_LIBRARY: 'COMPETENCY_LIBRARY',
  FEEDBACK_SETTINGS: 'FEEDBACK_SETTINGS',
};

export const DISCIPLINARY_ACTIONS_INTENT_ID_MAP = {
  PENDING: 'pendingDisciplinaryActions',
  ALL: 'allDisciplinaryActions',
  ADMIN_REPORTS: 'adminReports',
  SETTINGS: 'disciplinaryActionsSettings',
};

export const ENGAGEMENT_INTENTS = {
  ENGAGEMENT_PENDING_ON_ME: 'ENGAGEMENT_PENDING_ON_ME',
  ENGAGEMENT_COMPLETED_SURVEYS: 'ENGAGEMENT_COMPLETED_SURVEYS',
  ENGAGEMENT_REPORTS: 'ENGAGEMENT_REPORTS',
  ENGAGEMENT_SETTINGS: 'ENGAGEMENT_SETTINGS',
  ENGAGEMENT_COMPLETION_STATUS: 'ENGAGEMENT_COMPLETION_STATUS',
};

export const ONE_ON_ONE_INTENTS = {
  ONE_ON_ONE_LIST: 'ONE_ON_ONE_LIST',
  ARCHIVED_ONE_ON_ONE: 'ARCHIVED_ONE_ON_ONE',
  ONE_ON_ONE_GRAPH_REPORTS: 'ONE_ON_ONE_GRAPH_REPORTS',
  ONE_ON_ONE_TABLE_REPORTS: 'ONE_ON_ONE_TABLE_REPORTS',
  ONE_ON_ONE_SETTINGS: 'ONE_ON_ONE_SETTINGS',
  ONE_ON_ONE_DATA_EXPORTS: 'ONE_ON_ONE_DATA_EXPORTS',
};

export const REVIEW_INTENTS = {
  PENDING_ON_ME: 'PENDING_ON_ME',
  PENDING_ON_OTHERS: 'PENDING_ON_OTHERS',
  COMPLETED_BY_ME: 'COMPLETED_BY_ME',
  MY_PAST_REVIEWS: 'MY_PAST_REVIEWS',
  REVIEW_MANAGE: 'REVIEW_MANAGE',
  REVIEW_COMPLETION_STATUS: 'REVIEW_COMPLETION_STATUS',
  REVIEW_CALIBRATED_RESULTS: 'REVIEW_CALIBRATED_RESULTS',
  REVIEW_POST_REVIEW_ACTION_PLAN: 'REVIEW_POST_REVIEW_ACTION_PLAN',
  REVIEW_DETAILED_REPORTS: 'REVIEW_DETAILED_REPORTS',
  REVIEW_GOAL_WEIGHTAGE_REPORT: 'REVIEW_GOAL_WEIGHTAGE_REPORT',
};

export const COMPENSATION_INTENTS = {
  COMPENSATION_PLANNING: 'COMPENSATION_PLANNING',
  COMPENSATION_SETTINGS: 'COMPENSATION_SETTINGS',
};

export const POINTS_INTENTS = {
  MY_POINTS: 'MY_POINTS',
  POINTS_STATUS: 'POINTS_STATUS',
  POINTS_SETTINGS: 'POINTS_SETTINGS',
};

export const REWARDS_INTENTS = {
  MY_REWARDS_DASHBOARD: 'MY_REWARDS_DASHBOARD',
  REWARDS_LEADERBOARD: 'REWARDS_LEADERBOARD',
  REWARDS_DASHBOARD: 'REWARDS_DASHBOARD',
  REWARDS_SETTINGS: 'REWARDS_SETTINGS',
};
